import { createSlice } from '@reduxjs/toolkit';
import appapi from '../../api/apiClient';

//Initial State of appslice
const initialState = {
    countryList: [],
    traderList:[],

}

const appSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {

        setCountry(state, action) {
            state.countryList = action.payload
        },
    }
})

/**
 * @function initRouteList
 * @returns The updated logged In Route List
 */
export const initCountryList = () => {
    return async (dispatch, getState) => {
        const { userId } = getState().auth;
        if (userId) {
            const response = await appapi.get(`common/country`);
            if (response.ok) {
                const data = response.data;
                if (data.status === '7400') {
                    dispatch(setCountry(data.response || []));
                }
            }
        }
    };
};


export const { setCountry } = appSlice.actions
export default appSlice.reducer